import { render, staticRenderFns } from "./SetExpenditure.vue?vue&type=template&id=64023fe8&scoped=true&"
import script from "./SetExpenditure.vue?vue&type=script&lang=js&"
export * from "./SetExpenditure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64023fe8",
  null
  
)

export default component.exports